export enum FilterPanelEnum {
  FILTERS,
  COVERAGE_OPTIONS
}